import { Dispatch, SetStateAction, useState } from "react";
import { Button, Modal } from "@mui/material";
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import CloseIcon from '@mui/icons-material/Close';
import AIFeedback from "./AIFeedback";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function ViewCard({ open, onClose, setOpen }: ModalProps) {
    const [openAIModal, setOpenAIModal] = useState(false);

    return (
        <><Modal className="modal ai_style" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Preview Journal</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>
                    <article className="expert_listing_card">
                        <figure className="expert_listing_figure">
                            <img src="/static/images/expert1.jpg" alt="Expert insights" />
                            <p className="figure_overlay">
                                <span className="cat">Expert insights</span>

                            </p>


                        </figure>

                        <div className="card_info1">
                            <h2>Legal Essentials for UAE Artisan</h2>

                            <p>
                                Understanding licensing, permits, and regulations for selling handmade goods in UAE.
                            </p>

                            <div className="author_flex">
                                <figure>
                                    <img src="/static/images/user_placeholder.png" alt="Ahmad Khalil" />
                                    <figcaption>Ahmad Khalil</figcaption>
                                </figure>

                                <p>
                                    <AccessAlarmIcon />
                                    12 min
                                </p>
                            </div>

                            <ul>
                                <li>legal</li>
                                <li>business</li>
                                <li>UAE</li>
                            </ul>


                        </div>
                    </article>
                    <div className="footer_btn_flex">
                        <Button className="btn btn_primary" onClick={() => setOpenAIModal(true)}>  Verify with AI and Publish</Button>
                    </div>
                </div>
            </div>
        </Modal><AIFeedback
                open={openAIModal}
                onClose={() => setOpenAIModal(false)}
                setOpen={setOpenAIModal} /></>
    );
}
